module.exports = __webpack_public_path__ + "9e5dd256aca7fdc35428ea0119d4c79d.svg";